import React from 'react';
import AtlasMap from './components/AtlasMap';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white shadow-sm py-4 px-6 z-10 border-b border-gray-100">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-3xl text-blue-600">🗺️</span>
            <div>
              <h1 className="text-xl font-bold text-gray-900 leading-tight">Community Atlas</h1>
              <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">Discover Local Connections</p>
            </div>
          </div>
          <div className="flex items-center gap-4 text-right">
            <span className="hidden md:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">Live Network</span>
            <p className="text-[10px] text-gray-400 font-mono bg-gray-100 px-2 py-1 rounded">v1.2.3</p>
          </div>
        </div>
      </header>

      <main className="flex-grow p-4 md:p-8">
        <div className="max-w-6xl mx-auto h-[700px]">
          <AtlasMap />
        </div>
        <footer className="max-w-6xl mx-auto mt-12 pb-8 text-center border-t border-gray-200 pt-8">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Community Atlas Team.
          </p>
        </footer>
      </main>
    </div>
  );
}

export default App;